import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
:root{
    --red: #FF0000;
}
  *{
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: 'Poppins', sans-serif;
      font-weight: 400;

      h1, h2, h3, h4, h5, h6, strong {
        margin: 10px;
        font-weight: 600;
  }
  h1{
    font-size: 2rem;
  }

  h2{
    font-size: 1.5rem;
  }

  p{
    font-size: 1rem;
  }
  li{
    font-size: 1rem;
  }

  button{ 
      cursor: pointer;
    }
      [disabled]{
      opacity: 0.6;
      cursor: not-allowed;
  }
  
  @media (max-width: 1080px) {
    h1 {
    font-size: 1.5rem;
  }h2 {
    font-size: 1.2rem;
  }
  p{
    font-size: 0.8rem;
  }
  li{
    font-size: 0.8rem;
  }
 }
}`;
